(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen-banners/assets/react/row-banner.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen-banners/assets/react/row-banner.js');

'use strict';

const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect;
const rowBanner = svs.numbergames.andra_chansen_banners.rowBanner;

const AndraChansenRowBanner = _ref => {
  let chances = _ref.chances,
    endDate = _ref.endDate,
    isAndraChansenPeriodic = _ref.isAndraChansenPeriodic,
    isSubscription = _ref.isSubscription,
    shouldShowIcon = _ref.shouldShowIcon,
    size = _ref.size,
    classNames = _ref.classNames;
  const ref = useRef();
  useEffect(() => {
    const row = rowBanner({
      chances,
      endDate,
      isAndraChansenPeriodic,
      isSubscription,
      shouldShowIcon,
      size,
      classNames
    });
    ref.current.appendChild(row.render());
    return function cleanup() {
      if (ref.current) {
        ref.current.innerHTML = '';
      }
    };
  }, [classNames, chances, isSubscription, size, shouldShowIcon, endDate, isAndraChansenPeriodic]);
  return React.createElement("div", {
    ref: ref
  });
};
svs.numbergames.ReactAndraChansenBanners.AndraChansenRowBanner = AndraChansenRowBanner;

 })(window);